import { render } from "./Depilation.vue?vue&type=template&id=74320997&scoped=true"
import script from "./Depilation.vue?vue&type=script&lang=js"
export * from "./Depilation.vue?vue&type=script&lang=js"

import "./Depilation.vue?vue&type=style&index=0&id=74320997&scoped=true&lang=css"
import "./Depilation.vue?vue&type=style&index=1&id=74320997&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74320997"]])

export default __exports__